import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/system';

const NoDealsFilterMessage = ({
  resetFilters
}: {
  resetFilters: () => void;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2 as any, // Adds spacing between elements
        padding: 3 as any,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        boxShadow: 1,
        textAlign: 'center',
        maxWidth: '600px',
        margin: '0 auto 12px auto'
      }}
    >
      {/* Descriptive Text */}
      <Typography
        variant="h6"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: 'bold',
          mb: 1
        }}
      >
        No Deals Match Your Current Filters
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          mb: 2
        }}
      >
        It looks like there are no deals that match your selected filters. Try
        resetting your filters to see all available deals.
      </Typography>

      {/* Reset Filters Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={resetFilters}
        sx={{
          textTransform: 'none',
          fontWeight: 'bold',
          padding: '8px 24px',
          borderRadius: 2,
          boxShadow: 2,
          '&:hover': {
            boxShadow: 4,
            backgroundColor: theme.palette.primary.dark
          }
        }}
      >
        Reset Filters
      </Button>
    </Box>
  );
};

export default NoDealsFilterMessage;
